/* eslint-disable */
import React, { Component } from 'react';
import { DtpContentContainer, DtpAccordionGroup, DtpAccordionPanel } from 'dtp-react-components';
import { Input, Button, Grid } from '../../components';
import ModalAlertaNumeroNegativo from '../calculador-amd/ModalAlertaNumeroNegativo';
import { msgsCalculadorConversorNumeroNegativo } from '../../utils/constants';

class Calculador extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalAlerta: false,
      calculadorParcelas: {
        parcelaAno: null,
        parcelaMes: null,
        parcelaDia: null,
        parcelaInferiorAno: null,
        parcelaInferiorMes: null,
        parcelaInferiorDia: null,
        resultadoAno: null,
        resultadoMes: null,
        resultadoDia: null,
        ultimaOperacao: null,
      },
    };
  }

  handleModal = (modal) => {
    this.setState({ [modal]: !this.state[modal] });
  }

  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  handleChangeParcelas = (changeObj, name) => {
    const { calculadorParcelas } = { ...this.state };
    this.setState({
      calculadorParcelas: {
        ...calculadorParcelas,
        [name]: changeObj.value,
      },
    });
  }

  converterValoresParaTipoNumerico = (valor) => {
    let retorno = null;
    if (valor) {
      retorno = Number(valor);
    }
    return retorno;
  }


  handleCalcularSoma = () => {
    const { calculadorParcelas } = { ...this.state };
    const anos = calculadorParcelas.parcelaAno ? calculadorParcelas.parcelaAno : 0;
    const meses = calculadorParcelas.parcelaMes ? calculadorParcelas.parcelaMes : 0;
    const dias = calculadorParcelas.parcelaDia ? calculadorParcelas.parcelaDia : 0;
    const anosInf = calculadorParcelas.parcelaInferiorAno ? calculadorParcelas.parcelaInferiorAno : 0;
    const mesesInf = calculadorParcelas.parcelaInferiorMes ? calculadorParcelas.parcelaInferiorMes : 0;
    const diasInf = calculadorParcelas.parcelaInferiorDia ? calculadorParcelas.parcelaInferiorDia : 0;

    let adicionarAno = 0;
    let adicionarMes = 0;
    let somaMes = 0;
    let somaAno = 0;
    let somaDia = 0;
    const restoMes = 0;
    const restoAno = 0;
    const mes = 1;
    const ano = 12;
    const diasMes = 30;

    somaMes = Math.trunc(Number(dias) + Number(diasInf));
    somaAno = Math.trunc(Number(meses) + Number(mesesInf));
    somaDia = Math.trunc(Number(dias) + Number(diasInf));

    if (somaDia > diasMes) {
      somaDia = somaDia - diasMes;
      somaMes = somaMes + mes;
    }
    if (somaAno >= '12') {
      adicionarAno = somaAno / ano;
    }

    if (somaMes >= '30') {
      adicionarMes = somaMes / mes;
    }

    calculadorParcelas.resultadoAno = Math.trunc(Number(anos) + Number(anosInf));
    calculadorParcelas.resultadoMes = Math.trunc(Number(meses) + Number(mesesInf));
    calculadorParcelas.resultadoDia = Math.trunc(Number(dias) + Number(diasInf));
    calculadorParcelas.ultimaOperacao = 'soma';

    if (adicionarAno !== 0 && calculadorParcelas.resultadoAno) {
      calculadorParcelas.resultadoAno = Math.trunc((calculadorParcelas.resultadoAno) + (Number(adicionarAno)));
      calculadorParcelas.resultadoMes = Math.trunc((Number(restoAno)));
    }

    if (adicionarMes !== 0 && calculadorParcelas.resultadoMes) {
      calculadorParcelas.resultadoMes = Math.trunc((calculadorParcelas.resultadoMes) + (Number(adicionarMes)));
      calculadorParcelas.resultadoDia = Math.trunc((Number(restoMes)));
    }

    this.setState({
      calculadorParcelas: { ...this.state.calculadorParcelas },
    });
  }

  handleCalcularSubtracao = () => {
    const { calculadorParcelas } = { ...this.state };
    let resultadoAnos = 0;
    let resultadoMeses = 0;
    let resultadoDias = 0;
    const anos = calculadorParcelas.parcelaAno ? calculadorParcelas.parcelaAno : 0;
    const meses = calculadorParcelas.parcelaMes ? calculadorParcelas.parcelaMes : 0;
    const dias = calculadorParcelas.parcelaDia ? calculadorParcelas.parcelaDia : 0;
    const anosInf = calculadorParcelas.parcelaInferiorAno ? calculadorParcelas.parcelaInferiorAno : 0;
    const mesesInf = calculadorParcelas.parcelaInferiorMes ? calculadorParcelas.parcelaInferiorMes : 0;
    const diasInf = calculadorParcelas.parcelaInferiorDia ? calculadorParcelas.parcelaInferiorDia : 0;
    let operacaoAno = 0;
    let operacaoAnoInf = 0;
    let operacaoMes = 0;
    let operacaoMesInf = 0;
    let operacaoDia = 0;
    let operacaoDiaInf = 0;
    const acrescentarDia = 1;
    const acrescentarDias = 30;
    const reduzirMes = 1;
    const acrescentarMeses = 12;
    const reduzirAno = 1;
    operacaoAno = Math.trunc(Number(anos));
    operacaoAnoInf = Math.trunc(anosInf);
    operacaoMes = Math.trunc(Number(meses));
    operacaoMesInf = Math.trunc(Number(mesesInf));
    operacaoDia = Math.trunc(Number(dias));
    operacaoDiaInf = Math.trunc(Number(diasInf));

    // Se necessário empresta 30 dias de 1 mês
    if (operacaoDia < operacaoDiaInf) {
      operacaoDia = Math.trunc(operacaoDia + acrescentarDias);
      operacaoMes = Math.trunc(operacaoMes - reduzirMes);
    }
    if (operacaoMes < operacaoMesInf) {
      // Se necessário empresta 12 meses de 1 ano
      operacaoMes = Math.trunc(operacaoMes + acrescentarMeses);
      operacaoAno = Math.trunc(operacaoAno - reduzirAno);
    }

    resultadoAnos = operacaoAno - operacaoAnoInf;
    resultadoMeses = operacaoMes - operacaoMesInf;
    resultadoDias = operacaoDia - operacaoDiaInf;

    calculadorParcelas.resultadoAno = Math.trunc((Number(resultadoAnos)));
    calculadorParcelas.resultadoMes = Math.trunc((Number(resultadoMeses)));
    calculadorParcelas.resultadoDia = Math.trunc((Number(resultadoDias + acrescentarDia)));
    calculadorParcelas.ultimaOperacao = 'subtracao';
    // Exibe mensagem de erro se valor do resultado ano for negativo
    if (resultadoAnos < 0) {
      this.handleModal('showModalAlerta');
    }

    this.setState({
      calculadorParcelas: { ...this.state.calculadorParcelas, calculadorParcelas },
    });
  }

  handleReset = () => {
    const { calculadorParcelas } = { ...this.state };
    calculadorParcelas.parcelaAno = '';
    calculadorParcelas.parcelaMes = '';
    calculadorParcelas.parcelaDia = '';
    calculadorParcelas.parcelaInferiorAno = '';
    calculadorParcelas.parcelaInferiorMes = '';
    calculadorParcelas.parcelaInferiorDia = '';
    calculadorParcelas.resultadoAno = '';
    calculadorParcelas.resultadoMes = '';
    calculadorParcelas.resultadoDia = '';
    this.setState({
      calculadorParcelas: { calculadorParcelas },
    });
  }

  handleProximo = () => {
    const { calculadorParcelas } = { ...this.state };

    calculadorParcelas.parcelaInferiorAno = '';
    calculadorParcelas.parcelaInferiorMes = '';
    calculadorParcelas.parcelaInferiorDia = '';

    calculadorParcelas.parcelaAno = calculadorParcelas.resultadoAno;
    calculadorParcelas.parcelaMes = calculadorParcelas.resultadoMes;

    // Verifica a operação para reduzir o dia acrescentado na subtração
    if (calculadorParcelas.ultimaOperacao === 'subtracao') {
      calculadorParcelas.parcelaDia = Math.trunc(calculadorParcelas.resultadoDia - 1);
    } else {
      calculadorParcelas.parcelaDia = calculadorParcelas.resultadoDia;
    }

    calculadorParcelas.resultadoAno = '';
    calculadorParcelas.resultadoMes = '';
    calculadorParcelas.resultadoDia = '';

    this.setState({
      calculadorParcelas: { ...calculadorParcelas },
    });
  }

  verificarPreenchimentoInputs = () => {
    // const { calculadorParcelas } = { ...this.state };
    let retorno = false;

    if (!(this.state.calculadorParcelas.parcelaAno ||
      this.state.calculadorParcelas.parcelaMes ||
      this.state.calculadorParcelas.parcelaDia)) {
      retorno = true;
    }

    return retorno;
  }

  verificarPreenchimentoInputsResultado = () => {
    const { calculadorParcelas } = { ...this.state };
    let retorno = false;

    if (!(calculadorParcelas.resultadoAno ||
      calculadorParcelas.resultadoMes ||
      calculadorParcelas.resultadoDia)) {
      retorno = true;
    }
    return retorno;
  }

  render() {
    return (
      <DtpContentContainer>
        <DtpAccordionGroup>
          <DtpAccordionPanel
            headingId="calculador"
            panelId="calculador-amd"
            icon="ico-calc"
            title="Soma/Subtração de Datas"
          >
            <div className="row">
              <Grid cols="2 2 2 2">
                <Input
                  showMask={false}
                  label="Anos"
                  maxLength="4"
                  integer
                  value={this.state.calculadorParcelas.parcelaAno}
                  onChange={e => this.handleChangeParcelas(e, 'parcelaAno')}
                />
              </Grid>
              <Grid cols="2 2 2 2">
                <Input
                  showMask={false}
                  label="Meses"
                  maxLength="2"
                  integer
                  value={this.state.calculadorParcelas.parcelaMes}
                  onChange={e => this.handleChangeParcelas(e, 'parcelaMes')}
                />
              </Grid>
              <Grid cols="2 2 2 2">
                <Input
                  showMask={false}
                  label="Dias"
                  integer
                  maxLength="2"
                  value={this.state.calculadorParcelas.parcelaDia}
                  onChange={e => this.handleChangeParcelas(e, 'parcelaDia')}
                />
              </Grid>
              <Grid cols="1 1 1 1">
                <Button
                  className="ico-plus"
                  mini
                  hint="Somar"
                  disabled={this.verificarPreenchimentoInputs()}
                  onClick={this.handleCalcularSoma}
                />
              </Grid>
              <Grid cols="1 1 1 1">
                <Button
                  className="ico-triangle-right2"
                  mini
                  hint="Próximo"
                  onClick={this.handleProximo}
                  disabled={this.verificarPreenchimentoInputsResultado()}
                />
              </Grid>
            </div>
            <div className="row">
              <Grid cols="2 2 2 2">
                <Input
                  showMask={false}
                  label="Anos"
                  integer
                  maxLength="4"
                  value={this.state.calculadorParcelas.parcelaInferiorAno}
                  onChange={e => this.handleChangeParcelas(e, 'parcelaInferiorAno')}
                />
              </Grid>
              <Grid cols="2 2 2 2">
                <Input
                  showMask={false}
                  label="Meses"
                  integer
                  maxLength="2"
                  value={this.state.calculadorParcelas.parcelaInferiorMes}
                  onChange={e => this.handleChangeParcelas(e, 'parcelaInferiorMes')}
                />
              </Grid>
              <Grid cols="2 2 2 2">
                <Input
                  showMask={false}
                  label="Dias"
                  integer
                  maxLength="2"
                  value={this.state.calculadorParcelas.parcelaInferiorDia}
                  onChange={e => this.handleChangeParcelas(e, 'parcelaInferiorDia')}
                />
              </Grid>
              <Grid cols="1 1 1 1">
                <Button
                  className="ico-minus"
                  mini
                  disabled={this.verificarPreenchimentoInputs()}
                  hint="Subtrair"
                  onClick={this.handleCalcularSubtracao}
                />
              </Grid>
              <Grid cols="1 1 1 1">
                <Button
                  className="ico-eraser"
                  mini
                  hint="Limpar"
                  onClick={this.handleReset}
                  disabled={this.verificarPreenchimentoInputs()}
                />
              </Grid>
            </div>
            <div className="row">
              <Grid cols="2 2 2 2">
                <Input
                  showMask={false}
                  label="Anos"
                  integer
                  disabled
                  value={this.state.calculadorParcelas.resultadoAno}
                />
              </Grid>
              <Grid cols="2 2 2 2">
                <Input
                  showMask={false}
                  label="Meses"
                  integer
                  disabled
                  value={this.state.calculadorParcelas.resultadoMes}
                />
              </Grid>
              <Grid cols="2 2 2 2">
                <Input
                  showMask={false}
                  label="Dias"
                  integer
                  disabled
                  value={this.state.calculadorParcelas.resultadoDia}
                />
              </Grid>
            </div>
            <div className="row">
              <Grid cols="12 12 12 12">
                <p className="observacaoCalculador">
                  <b>* Observações:</b>
                </p>
                <p className="observacaoCalculador">
                  Na Soma não utilize datas para o ano, ex.: 1999,2000. Tal prática ocorrerá em valor absurdo para o número de anos.
                </p>
                <p className="observacaoCalculador">
                  Na Subtração podem ser utilizadas datas para o ano, ex.: 1999,2000.
                </p>
              </Grid>
            </div>
            {this.state.showModalAlerta ? (
              <ModalAlertaNumeroNegativo
                alertas={[msgsCalculadorConversorNumeroNegativo.aviso]}
                aceitar={this.handleFechamentoModalAlerta}
                handleModal={this.handleFechamentoModalAlerta}
                showModal={this.state.showModalAlerta}
              />
            ) : ''}
          </DtpAccordionPanel>
        </DtpAccordionGroup>
      </DtpContentContainer>
    );
  }
}
Calculador.propTypes = { };

export default Calculador;




// WEBPACK FOOTER //
// ./src/pages/calculador-amd/Calculador.jsx